import { Injectable } from '@angular/core';

import { MxBrowserStorageService, MxStorageType } from './mx.browser-storage.service';

// eslint-disable-next-line max-len
@Injectable({
  providedIn: 'root',
})
export class MxAppSidebarService {
  private _sidebarStatic?: boolean;

  get sidebarStatic(): boolean {
    return this._sidebarStatic;
  }
  set sidebarStatic(value: boolean) {
    MxBrowserStorageService.set(MxStorageType.Local, 'sidebar-static', value);
    this._sidebarStatic = value;
  }

  private _sidebarActive?: boolean;

  get sidebarActive(): boolean {
    return this._sidebarActive;
  }
  set sidebarActive(value: boolean) {
    MxBrowserStorageService.set(MxStorageType.Local, 'sidebar-active', value);
    this._sidebarActive = value;
  }

  constructor() {
    this._sidebarStatic = MxBrowserStorageService.get(MxStorageType.Local, 'sidebar-static');

    this._sidebarActive = MxBrowserStorageService.get(MxStorageType.Local, 'sidebar-active');
  }
}
